import uploadFilled from "../../assets/landingPageItems/uploadFilled.svg";
import refresh from "../../assets/landingPageItems/refresh.svg";
import transform from "../../assets/landingPageItems/transform.svg";
import download from "../../assets/landingPageItems/download.svg";
import goal from "../../assets/landingPageItems/goal.svg";
const HowItWorks = () => {
  const steps = [
    {
      title: "Step 1:",
      heading: "Upload Your File",
      description: "Drop in your sales exported data from any platform.",
      icon: uploadFilled,
    },
    {
      title: "Step 2:",
      heading: "Create Your Template",
      description:
        "One-time no-code setup in your bookkeeper’s preferred format.",
      icon: refresh,
    },
    {
      title: "Step 3:",
      heading: "Transform Automatically",
      description:
        "Our tool reshapes, standardizes, and maps your messy data instantly.",
      icon: transform,
    },
    {
      title: "Step 4:",
      heading: "Download Clean Output",
      description: "Get a tidy, formatted Excel or CSV — ready for accounting!",
      icon: download,
    },
    {
      title: "Goal",
      heading: "Bookkeeper-Ready Sheets",
      description: "Get a tidy, formatted Excel or CSV — ready for accounting!",
      icon: goal,
    },
  ];
  return (
    <section
      id="howitworks"
      className=" py-8 md:py-12 bg-white text-[#0e1065] font-raleway "
    >
      <div className="px-4 md:px-12 xl:pl-32 max-w-[2400px] mx-auto text-center ">
        <h2 className="text-4xl md:text-6xl font-audiowide  text-lightBlue">
          How It <span className="text-green-500">Works</span>
        </h2>
        <p className="w-full max-w-[800px] mt-4 md:mt-5 text-base md:text-lg text-lightBlue text-center mx-auto leading-relaxed">
          Ingest raw exports from marketplaces and POS systems.
          <br />
          Build your own reusable templates once — then automate them forever.
          <br />
          No more manual cleanup, no rigid standards — just fast, repeatable,
          bookkeeper-ready outputs that fit your workflow.
        </p>

        {/* Timeline */}
        <div className="mt-16 relative flex flex-col lg:flex-row justify-center items-center gap-8 lg:items-baseline">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative flex lg:flex-col w-full justify-center"
            >
              {/* Connector Line (Horizontal for lg, Vertical for mobile) */}
              {index < steps.length - 1 && (
                <div
                  className={`
                    absolute
                    ${/* desktop horizontal */ ""}
                    hidden lg:block top-8 left-12 h-0.5 
                    ${index === 0 ? "bg-lightGreen" : "bg-lightBlue"} 
                    w-full
                  `}
                />
              )}
              {index == steps.length - 1 && (
                <div
                  className={`
                    absolute
                    ${/* desktop horizontal */ ""}
                    hidden lg:block top-8 left-12 h-0.5 
                    ${index === 0 ? "bg-lightGreen" : "bg-lightBlue"} 
                    w-full
                  `}
                />
              )}

              {/* Mobile vertical connector */}

              {/* Icon */}
              <div className="z-50 pr-2 md:px-4 w-20 md:w-24 lg:w-28 flex-none">
                <img
                  src={step.icon}
                  alt={step.title}
                  className="min-h-14 h-[60px] select-none "
                  draggable="false"
                />
                {index < steps.length - 1 && (
                  <div
                    className={`
                        relative 
                        lg:hidden left-8 w-0.5 h-full 
                        ${index === 0 ? "bg-lightGreen" : "bg-lightBlue"} 
                        
                      `}
                  />
                )}
                {index == steps.length - 1 && (
                  <div
                    className="
                        relative 
                        lg:hidden left-8 w-0.5 h-full
                      bg-lightBlue"
                  />
                )}
              </div>

              {/* Step Text */}
              <div className="mt-4 py-2 md:py-4 px-4 bg-white  rounded-xl shadow-md max-w-xs text-start  font-bold text-2xl lg:text-3xl">
                <h3 className="font-bold text-2xl md:text-3xl">
                  {step.title}{" "}
                </h3>
                <p className="text-green-500">{step.heading}</p>
                {step.description && (
                  <p className="text-sm font-normal md:text-base text-gray-600 mt-1">
                    {step.description}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
